import { Box, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import '../../theme/newPost.css';

interface TitleStepProps {
  title: string;
  maxTitleChars: number;
  onChange: (title: string) => void;
}

const TitleStep: React.FC<TitleStepProps> = ({ title, maxTitleChars, onChange }) => {
  const { t } = useTranslation();
  const isMaxLength = title.length >= maxTitleChars;

  return (
    <Box className="new-post-step-content">
      <TextField
        value={title}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t('new_post.title_placeholder')}
        inputProps={{ maxLength: maxTitleChars }}
        fullWidth
        variant="outlined"
        className="new-post-text-field"
      />
      <div className={`new-post-character-count ${isMaxLength ? 'new-post-character-count-error' : ''}`}>
        <Typography variant="caption">
          {t('new_post.title_helper')}
        </Typography>
        <Typography variant="caption">
          {title.length}/{maxTitleChars}
        </Typography>
      </div>
    </Box>
  );
};

export default TitleStep;
